/* eslint-disable */
// @ts-nocheck

import React, { useContext } from 'react'

import { useBusinessDataQuery } from '@/hooks/business/useBusinessDataQuery'
import { useBusinessPackagesQuery } from '@/hooks/business/useBusinessPackagesQuery'

import CurrencyInput from '../../../components/forms/CurrencyInput'
import Input from '../../../components/forms/Input'
import InputColor from '../../../components/forms/InputColor'
import InputDuration from '../../../components/forms/InputDuration'
import Multiselect from '../../../components/forms/Multiselect'
import Select from '../../../components/forms/Select'
import TextArea from '../../../components/forms/TextArea'
import Toggle from '../../../components/forms/Toggle'
import Button from '../../../components/misc/Button'
import { SelectInterface } from '../../../interfaces/InterfacesLocal'
import { useAppSelector } from '../../../store/hooks'
import { ProductContext } from './NewWizardContainer'

const ProductForm = () => {
  const { business } = useAppSelector((state) => state.init)
  const { productCategories, measures, salesCategories, areas } =
    useAppSelector((state) => state.nomenclator)
  const { control, stepDown, watch } = useContext(ProductContext)
  const { businessData, isLoadingBusinessData, isErrorBusinessData } =
    useBusinessDataQuery({})
  const { businessPackages } = useBusinessPackagesQuery({
    params: { businessId: businessData?.id ?? 0 },
    options: {
      enabled:
        !!businessData?.id && !isLoadingBusinessData && !isErrorBusinessData,
    },
  })

  const productType = control?._getWatch('type') ?? ''

  // const module_booking =
  //   business?.configurationsKey.find((itm) => itm.key === 'module_booking')
  //     ?.value === 'true'
  const module_booking = businessPackages?.find(
    (itm) => itm.code === 'M_BOOKING'
  )?.isActive

  //Data for Select and Multiselect Components ---------------------------------------------------------------------
  const selectSalesCategory: SelectInterface[] = []
  salesCategories.map((cat) =>
    selectSalesCategory.push({
      name: cat.name,
      id: cat.id,
    })
  )

  const selectStockCategory: SelectInterface[] = []
  productCategories?.forEach((cat) =>
    selectStockCategory.push({
      name: cat.name,
      id: cat.id,
    })
  )

  const selectMeasure: SelectInterface[] = []
  measures.forEach((item) =>
    selectMeasure.push({
      id: item.code,
      name: item.value,
    })
  )

  const productionAreas: SelectInterface[] = []
  areas?.forEach(
    (item) =>
      item.type === 'MANUFACTURER' &&
      productionAreas.push({
        name: item.name,
        id: item.id,
      })
  )

  //----------------------------------------------------------------------------------------------------
  const price = control?._getWatch('prices')
  return (
    <>
      <div className="h-96 overflow-y-visible rounded border border-slate-300 p-2">
        <div className={`grid grid-cols-2 gap-3`}>
          <Input
            control={control}
            label="Nombre"
            name="name"
            placeholder="Inserte el nombre del producto"
            rules={{ required: 'Este campo es requerido' }}
          />
          {['STOCK', 'MENU', 'SERVICE', 'ADDON', 'COMBO', 'VARIATION'].includes(
            productType
          ) && (
            <Select
              control={control}
              data={selectSalesCategory}
              label="Categoría de Venta"
              name="salesCategoryId"
            />
          )}

          {[
            'STOCK',
            'MENU',
            'SERVICE',
            'ADDON',
            'COMBO',
            'VARIATION',
            'ASSET',
            'INPUT',
          ].includes(productType) && (
            <CurrencyInput
              byDefault={
                !price
                  ? { price: 0, codeCurrency: business?.costCurrency! }
                  : price
              }
              control={control}
              currencies={
                business?.availableCurrencies.map(
                  (currency) => currency.code
                ) ?? []
              }
              defaultCurrency={business?.costCurrency!}
              label="Precio de venta"
              name="prices"
              placeholder="$0.00"
            />
          )}

          {['STOCK', 'RAW', 'MANUFACTURED', 'WASTE', 'ASSET'].includes(
            productType
          ) && (
            <Select
              control={control}
              data={selectStockCategory}
              label="Categoría de almacén"
              name="productCategoryId"
            />
          )}

          {['RAW', 'MANUFACTURED', 'WASTE'].includes(productType) && (
            <Select
              control={control}
              data={selectMeasure}
              label="Unidad de medida"
              name="measure"
              rules={{ required: 'Este campo es requerido' }}
            />
          )}

          {['MENU', 'ADDON'].includes(productType) && (
            <div className="">
              <Multiselect
                control={control}
                data={productionAreas}
                disabled={business?.subscriptionPlan.code === 'FREE'}
                label="Areas de producción"
                name="listProductionAreas"
              />
            </div>
          )}
          {['SERVICE'].includes(productType) && module_booking && (
            <>
              <div className="">
                <InputColor
                  control={control}
                  label="Color identificativo"
                  name="color"
                />
              </div>
              <div className=""></div>
            </>
          )}
          {['SERVICE'].includes(productType) && module_booking && (
            <div className="col-span-2 grid grid-cols-2 items-center">
              <div className="">
                <Toggle
                  control={control}
                  name="hasDuration"
                  title="Definir duración"
                />
              </div>
              <div className="mb-2">
                {watch('hasDuration') && (
                  <InputDuration
                    control={control}
                    label="Duración"
                    name="duration"
                  />
                )}
              </div>
            </div>
          )}

          <div className="col-span-2">
            <TextArea
              control={control}
              label="Descripción"
              name="description"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 py-2">
        <Button
          action={stepDown}
          color="slate-500"
          full
          name="Atrás"
          outline
          textColor="slate-600"
        />
        <Button color="slate-600" full name="Siguiente" type="submit" />
      </div>
    </>
  )
}

export default ProductForm
